// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraDatePickerCalendarComponentTemplate from '@front/templates/TerceraDatePickerCalendarComponentTemplate.html';
import { Control } from '../Control';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
import { generateDateTimePickerLocalization } from './DateTimePickerLocalization';
export class TerceraDatePickerCalendarComponent extends Control {
    constructor() {
        super(...arguments);
        this.picker = null;
        this.callback = null;
    }
    getType() {
        return ControlsTypes.TerceraDatePickerCalendarComponent;
    }
    oninit() {
        super.oninit();
        this.onDateChanged = this.onDateChanged.bind(this);
    }
    oncomplete() {
        super.oncomplete();
        const options = {
            prevHtml: '<svg><use href="assets/webdesktop/web-desktop-sprite.svg#ArrowLeft"></use></svg>',
            nextHtml: '<svg><use href="assets/webdesktop/web-desktop-sprite.svg#ArrowRight"></use></svg>',
            maxDate: new Date(),
            onSelect: this.onDateChanged,
            toggleSelected: false,
            isSetPosition: this.get('isSetPosition')
        };
        this.picker = window.$(this.find('div')).datepicker(options).data('datepicker');
        this.localize();
        this.picker.show();
    }
    onDateChanged(_formattedDate, date) {
        if (isNullOrUndefined(this.callback))
            return;
        if (date instanceof Date) {
            this.callback(date);
            return;
        }
        if (Array.isArray(date) && date.length > 0 && date[0] instanceof Date) {
            this.callback(date[0]);
            return;
        }
        this.callback(null);
    }
    localize() {
        if (isNullOrUndefined(this.picker))
            return;
        this.picker.update('language', generateDateTimePickerLocalization());
    }
}
Control.extendWith(TerceraDatePickerCalendarComponent, {
    template: TerceraDatePickerCalendarComponentTemplate,
    data: () => ({
        visible: true,
        isSetPosition: true
    }),
    picker: null
});
